<div [ngStyle]="{'height':_height||defaultHeight}">
  <app-widgets-toolbar class="pb-16" *ngIf="_showToolbar" [colour]="toolbarColour || '#0277bd'" [widgets]="widgets" (lockToggled)="toggleLock($event)" (addWidget)="addWidget($event)"></app-widgets-toolbar>

  <div class="gridster-container" [ngClass]="{'with-shadow mt-12': border}">
  <gridster [options]="_options" class="mat-drawer-container" style="background-color: white;">
      <gridster-item [item]="item.config" *ngFor="let item of _layout" [class.selected-field]="selectedField === item" class="no-transition transparent-bg gridster-item">

        <div *ngIf="!_locked" class="widget-options">
            <button id="dragbtn" mat-mini-fab class="drag-handler" style="width:30px;height:30px;" matTooltip="{{'Customise ' + (item.title || item.name)}}" aria-label="{{'Customise ' + (item.title || item.name)}}">
              <mat-icon>open_with</mat-icon>
            </button>
            <button id="removebtn" mat-mini-fab (mousedown)="removeWidget($event, item)" (touchstart)="removeWidget($event, item)" style="width:30px;height:30px;" matTooltip="{{'Delete ' + (item.title || item.name)}}" aria-label="{{'Delete ' + (item.title || item.name)}}">
              <mat-icon>delete</mat-icon>
            </button>
            <button *ngIf="item.configurable" id="settingsbtn" mat-mini-fab (click)="displayWidgetSettings($event, item)" style="width:30px;height:30px;" matTooltip="{{'Edit ' + (item.title || item.name) + ' Settings'}}" aria-label="{{'Edit' + (item.title || item.name) + ' Settings'}}">
              <mat-icon>settings</mat-icon>
            </button>
        </div>

        <div class="gridster-item-content no-padding" [class.mat-card]="!contentBackgroundColor" style="height: 100%; padding:1px;" [style.background-color]="contentBackgroundColor || 'white'">
          <ndc-dynamic [ndcDynamicComponent]="item.widget" 
          [ndcDynamicInputs]="item.metadata"
          [ndcDynamicOutputs]="handleMetaChanges"></ndc-dynamic>
        </div>

      </gridster-item>

    </gridster>

 </div>
</div>
